<template>
  <div class="block__wrapper" v-if="data.length">
    <div
      class="block__item stat"
      v-for="(stat, index) of parsedData"
      :key="index"
    >
      <bim-text type=main>{{ stat.name }}</bim-text>
      <bim-text type=h4 bold>{{ stat.value | numberSpacing }}</bim-text>
    </div>
  </div>
</template>

<script>
export default {
  name: "StatNumber",
  data() {
    return {
      data: []
    }
  },
  created() {
    console.log('hellog from stat-number')
    axios.get('/web-api/elastic/usersperyear')
      .then(r => r.data)
      .then(stats => {
        console.log('data', stats)
        this.data = stats[0].data
      })
  },
  computed: {
    parsedData() {
      return this.data.slice(0, 3)
    }
  },
  filters: {
    numberSpacing(val) {
      return new Intl.NumberFormat('ru').format(val)
    },
  }
}
</script>

<style scoped lang="scss">
.block__wrapper {
  display: flex;
  flex-wrap: wrap;

  .block__item {
    flex: 1 0 33.3333%;

    &:first-child {
      margin-bottom: 24px;
    }
  }
}
</style>
